import TopBanners from 'pix-orga/components/banner/top-banners';

<template>
  <main class="main-content__body page">
    <TopBanners />
    {{outlet}}
  </main>
</template>
